import React, { useState } from "react";
import { BsInstagram, BsWhatsapp } from "react-icons/bs";
import { FaFacebookF } from "react-icons/fa";

import { client } from "../../client";
import { AppWrap, MotionWrap } from "../../wrapper";
import { images } from "../../constants";
import "./Footer.scss";

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [cvDownloaded, setCvDownloaded] = useState(false);

  const handleChangeInput = (e) => {
    const { name, value } = e.target;

    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const contact = {
      _type: "contact",
      name: formData.name,
      email: formData.email,
      message: formData.message,
    };

    client.create(contact).then(() => {
      setLoading(false);
      setIsFormSubmitted(true);
    });
  };
  return (
    <>
      <h2 className="head-text">Take a coffee & chat with me</h2>

      <div className="app__footer socialIcons">
        <div>
          <a
            href="https://api.whatsapp.com/send?phone=9779847112497"
            target={"_blank"}
            rel="noreferrer"
          >
            <BsWhatsapp />
          </a>
        </div>
        <div>
          <a
            href="https://www.instagram.com/ccir.g/?hl=en"
            target={"_blank"}
            rel="noreferrer"
          >
            <BsInstagram />
          </a>
        </div>
        <div>
          <a
            href="https://www.facebook.com/ccir.gaire/"
            target={"_blank"}
            rel="noreferrer"
          >
            <FaFacebookF />
          </a>
        </div>
      </div>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="mailto:shishir.gaire11@gmail.com" className="p-text">
            shishir.gaire11@gmail.com
          </a>
        </div>

        <div className="app__footer-card">
          <img src={images.mobile} alt="mobile" />
          <a href="tel:+977 9847112497" className="p-text">
            +977 9847112497
          </a>
        </div>
      </div>

      {!isFormSubmitted ? (
        <form onSubmit={handleSubmit} className="app__footer-form app__flex">
          <div className="app__flex">
            <input
              required
              type="text"
              className="p-text"
              placeholder="Your Name"
              value={formData.name}
              name="name"
              onChange={handleChangeInput}
            />
          </div>

          <div className="app__flex">
            <input
              required
              type="text"
              className="p-text"
              placeholder="Your Email"
              value={formData.email}
              name="email"
              onChange={handleChangeInput}
            />
          </div>

          <div>
            <textarea
              required
              value={formData.message}
              name="message"
              className="p-text"
              placeholder="Your Message"
              onChange={handleChangeInput}
            ></textarea>
          </div>

          <button disabled={loading} type="submit" className="p-text">
            {loading ? "Sending" : "Send Message"}
          </button>
        </form>
      ) : (
        <div>
          <h3 className="head-text">Thank you for getting in touch!</h3>
        </div>
      )}

      <div className="app__footer-cv">
        <a
          className={cvDownloaded ? "disable-link" : ""}
          onClick={() => {
            setCvDownloaded(true);
          }}
          href="/Ccir-CV.pdf"
          download
          disabled={cvDownloaded}
        >
          {cvDownloaded ? "Thank you!" : "Download CV"}
        </a>
      </div>
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__whitebg"
);
